import { Link } from 'react-router-dom';

const strUserProgramRoles = (user) => {
  if (!user) return <div>NA</div>;

  const roles = [];

  (user.roles_all || []).forEach((role, idx) => {
    const roleKey = `role-${idx}`;

    if (role.program_name && role.program_id) {
        const programLink = `/program/view/${role.program_id}`;
        const rootProgramLink = role.parent_program_id
            ? `/program/view/${role.root_program_id}`
            : null;
        roles.push(
            <div key={roleKey}>
                {role.name} in&nbsp;
                {role.parent_program_name ? (
                    <>
                        <a href={programLink} target="_blank" rel="noopener noreferrer">
                            {role.program_name}
                        </a>
                        &nbsp;-&nbsp;
                        <a href={rootProgramLink} target="_blank" rel="noopener noreferrer">
                            {role.root_program_name}
                        </a>
                    </>
                ) : (
                    <a href={programLink} target="_blank" rel="noopener noreferrer">
                        {role.program_name}
                    </a>
                )}
            </div>
        );
    } else {
      roles.push(
        <div key={roleKey}>
          {role.name}
        </div>
      );
    }
  });

  return roles.length > 0 ? roles : <div>NA</div>;
}

export const USERS_COLUMNS = [
    {
        Header: "ID",
        accessor: "id",
    },
    {
        Header: "Employee ID",
        accessor: "employee_number",
        Cell: ({ row, value }) => (<span >{!!Number(value) ? value : ''}</span>)
    },
    {
        Header: "Email",
        accessor: "email",
    },
    {
        Header: "Name",
        accessor: "name",
        Cell: ({ row, value }) => { return <Link to={`/users/view/${row.original.id}`} >{value}</Link>},
    },
    {
        Header: "Phone",
        accessor: "phone",
    },
    {
        Header: "Role",
        accessor: "roles_all",
        Cell: ({ row, value }) => { return strUserProgramRoles(row.original)},
    },
    {
        Header: "Status",
        accessor: "user_status_id",
    },
   
]
export const USER_ADDRESS_COLUMNS = [
  {
    Header: "External ID",
    accessor: "external_id",
  },
  {
    Header: "Name",
    accessor: "name",
    minWidth: 250,
    width: 250,
    maxWidth: 250,
    Cell: ({ value }) => {
      // Cut to 15 chars + tooltip
      return (
        <div className="w-100">
          {value}
        </div>
      );
    },
    // Add this for styling
    style: { width: "200px", maxWidth: "200px", whiteSpace: "nowrap" },
  },
//   {
//     Header: "Street Address",
//     accessor: "street_address_1",
//   },
//   {
//     Header: "Street Address 2",
//     accessor: "street_address_2",
//   },
  {
    Header: "City",
    accessor: "city",
  },
//   {
//     Header: "State",
//     accessor: "state_province",
//   },
  {
    Header: "Postal Code",
    accessor: "postal_code",
  },
//   {
//     Header: "Country",
//     accessor: "country",
//   }
];
